module.exports = __webpack_public_path__ + "img/SMR.be39443.png";